import {ref} from "vue";

let keyWord = ref();
let isLogin = ref(true)

let alert = ref({
    'es1': false,
    'es2': false,
    'es3': false,
    "es4": false,
});

function falseAlert(){
    alert.value.es1 = alert.value.es2 = alert.value.es3 = alert.value.es4 = false
}

export default function useUtils(){
    return {
        keyWord,
        alert,
        isLogin,
        falseAlert,
    }
}